export default __webpack_public_path__ + "static/media/gallery-wip-neck_08.f841baf2.jpg";